import { SmartModalService } from 'app/core/services/smart-modal.service';
import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'itpx-edit-venue-confirm',
    templateUrl: './edit-venue-confirm.component.html',
    styleUrls: ['./edit-venue-confirm.component.css']
})
export class EditVenueConfirmComponent {

    constructor(private modalService: SmartModalService) { }

    onEditAll() {
        this.modalService.sendResult(ConfirmResult.All);
    }

    onEditThis() {
        this.modalService.sendResult(ConfirmResult.This);        
    }

    onCancel() {
        this.modalService.sendResult(null);
    }
}

export enum ConfirmResult {
    All = 1, This = 2
}



// WEBPACK FOOTER //
// ./src/app/solar/common/edit-venue-confirm/edit-venue-confirm.component.ts